import { useState } from "react";
import toast from 'react-hot-toast';

const GeneratedCredentialsDisplay = ({ credentials, onClose }) => {
  const [hasCopied, setHasCopied] = useState(false);

  return (
    <div className="bg-white rounded-lg border border-ase-blue p-6 w-full max-w-md flex flex-col gap-4">
      <h2 className="text-lg font-bold text-ase-blue">Generated Credentials</h2>

      <p className="text-sm text-gray-600">
        Copy these credentials and share them with the labourer directly. They will not be shown again once you close this dialog.
      </p>

      <div className="flex flex-col gap-0 border border-gray-200 rounded-lg overflow-hidden">
        <div className="flex items-center justify-between px-3 py-2 bg-gray-50 border-b border-gray-200">
          <p className="text-xs text-gray-500 font-semibold uppercase">Credentials</p>
          <button
            onClick={() => {
              navigator.clipboard.writeText(`Email: ${credentials.email}\nPassword: ${credentials.temporaryPassword}`);
              toast.success('Copied to clipboard');
            }}
            className="text-xs text-ase-blue underline font-semibold"
          >
            Copy all
          </button>
        </div>

        <div className="flex items-center justify-between gap-2 px-3 py-2 border-b border-gray-200">
          <div>
            <p className="text-xs text-gray-500 font-semibold uppercase">Email</p>
            <p className="text-sm font-mono">{credentials.email}</p>
          </div>
          <button
            onClick={() => { navigator.clipboard.writeText(credentials.email); toast.success('Copied to clipboard'); }}
            className="ase-button-primary text-xs px-2 py-1 shrink-0"
          >
            Copy
          </button>
        </div>

        <div className="flex items-center justify-between gap-2 px-3 py-2">
          <div>
            <p className="text-xs text-gray-500 font-semibold uppercase">Password</p>
            <p className="text-sm font-mono">{credentials.temporaryPassword}</p>
          </div>
          <button
            onClick={() => { navigator.clipboard.writeText(credentials.temporaryPassword); toast.success('Copied to clipboard'); }}
            className="ase-button-primary text-xs px-2 py-1 shrink-0"
          >
            Copy
          </button>
        </div>
      </div>

      <label className="flex items-center gap-2 cursor-pointer text-sm">
        <input
          type="checkbox"
          checked={hasCopied}
          onChange={e => setHasCopied(e.target.checked)}
          className="w-4 h-4"
        />
        I have copied these credentials
      </label>

      <button
        onClick={onClose}
        disabled={!hasCopied}
        className="ase-button-primary text-sm disabled:opacity-40 disabled:cursor-not-allowed"
      >
        Done
      </button>
    </div>
  );
};

export default GeneratedCredentialsDisplay;
